/* Cart-drawer press quotes (James, 2026-10-25, mock E): a strip of quote slides that slides left to right
   every 6 seconds (data-every on the track, in ms) and can be swiped, scrolled or arrowed by hand; any
   touch pauses the sliding for 12 seconds. The strip ends with a hidden copy of slide 1: once the strip
   settles on it, the script jumps back to slide 1 without animation, so the loop has no visible rewind.
   The drawer re-renders on cart changes, so every tick and every event looks the track up again and
   never keeps an element; the current slide lives on window so a fresh drawer carries on from it.
   Reduced motion: no automatic sliding (manual swiping still works). No DOM building, no fetch, no
   storage. Markup: snippets/bokja-cart-quotes.liquid. */
(function () {
  if (window.__bokjaCartQuotesBound) return;
  window.__bokjaCartQuotesBound = true;

  var TRACK = '[data-bokja-cart-quotes-track]';
  var PAUSE_MS = 12000;
  var hasScrollEnd = 'onscrollend' in window;

  function reduced() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }

  function findTrack() { return document.querySelector(TRACK); }

  function isOpen(track) {
    var dialog = track.closest && track.closest('dialog');
    return !dialog || dialog.open;
  }

  function paused() {
    var until = window.__bokjaCartQuotesPausedUntil;
    return typeof until === 'number' && Date.now() < until;
  }

  // Slides including the copy of slide 1, which is always the last.
  function count(track) { return track.querySelectorAll('.bokja-cart-quotes__slide').length; }

  function indexOf(track) { return Math.round(track.scrollLeft / track.clientWidth); }

  // No animation: the track's CSS scroll-behavior is smooth, and a plain scrollLeft write (or scrollTo
  // with behavior 'auto') follows it, so switch it off for this one write.
  function jump(track, index) {
    var before = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = index * track.clientWidth;
    track.style.scrollBehavior = before;
  }

  // The strip has stopped moving (after a tick or a swipe): leave the copy for the real slide 1 and
  // remember where it is.
  function settle(track) {
    track = track || findTrack();
    if (!track || !(track.clientWidth > 0)) return;
    var n = count(track);
    var index = indexOf(track);
    if (n > 1 && index >= n - 1) {
      jump(track, 0);
      index = 0;
    }
    window.__bokjaCartQuotesIndex = index;
  }

  function tick() {
    var track = findTrack();
    if (!track || !isOpen(track) || reduced() || paused()) return;
    var width = track.clientWidth;
    var n = count(track);
    if (!(width > 0) || n < 2) return;
    var index = indexOf(track);
    var stored = window.__bokjaCartQuotesIndex;
    // A fresh strip (the drawer re-rendered) starts on slide 1: put the current slide back first.
    if (typeof stored === 'number' && stored >= 0 && stored < n - 1 && stored !== index) {
      jump(track, stored);
      index = stored;
    } else if (index >= n - 1) {
      jump(track, 0);
      index = 0;
    }
    var next = index + 1;
    track.scrollTo({ left: next * width, behavior: 'smooth' });
    window.__bokjaCartQuotesIndex = next >= n - 1 ? 0 : next;
    if (next >= n - 1 && !hasScrollEnd) setTimeout(function () { settle(findTrack()); }, 700);
  }

  // A drawer built afresh (say, empty to full) arrives on slide 1; put the current slide back as it opens.
  function restore() {
    var track = findTrack();
    var stored = window.__bokjaCartQuotesIndex;
    if (!track || typeof stored !== 'number' || !(track.clientWidth > 0)) return;
    if (indexOf(track) !== stored) jump(track, stored);
  }

  window.__bokjaCartQuotesTick = tick;
  window.__bokjaCartQuotesSettle = settle;
  window.__bokjaCartQuotesRestore = restore;

  var first = findTrack();
  var every = parseInt(first && first.dataset && first.dataset.every, 10);
  if (!(every >= 1000)) every = 6000;
  setInterval(tick, every);

  // Everything below is delegated to document: the track node is replaced when the drawer re-renders.
  function onUser(event) {
    var target = event.target;
    if (target && target.closest && target.closest(TRACK)) window.__bokjaCartQuotesPausedUntil = Date.now() + PAUSE_MS;
  }
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
    document.addEventListener(type, onUser, { capture: true, passive: true });
  });

  // Scroll events do not bubble, hence capture. Without scrollend, settle 150 ms after the last scroll.
  var settleTimer;
  function onScroll(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(TRACK)) return;
    if (event.type === 'scrollend') return settle(target);
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () { settle(target); }, 150);
  }
  document.addEventListener(hasScrollEnd ? 'scrollend' : 'scroll', onScroll, true);

  // Dialog toggle events do not bubble, hence capture.
  document.addEventListener('toggle', restore, true);
})();
